import React from 'react';
import { CarCard } from '@perxis-auto/ui-kit/lib/components/CarCard';

import getCarDefaultDescription from '@/features/cars/helpers/getCarDescription';
import getCarDefaultTitle from '@/features/cars/helpers/getCarTitle';

import { CardTitleProps } from './CardTitle.types';

function CardTitle({
  data,
  isLoading = false,
  getCarTitle = getCarDefaultTitle,
  getCarDescription = getCarDefaultDescription,
}: CardTitleProps) {
  if (isLoading) {
    return <CarCard.TitleSkeleton />;
  }

  if (!data) {
    return null;
  }

  const title = getCarTitle(data);
  const description = getCarDescription(data);

  return <CarCard.Title title={title} description={description} />;
}

export default CardTitle;
